import { Box } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Header, Page, Toolbox } from 'redesign';
import { useTranslation } from 'react-i18next';
import {
  IssueDocumentFormContentProps,
  IssueDocumentFormData,
} from './issue-document-form-content.types';
import { IssueDocumentFormToolbox } from '../issue-document-form-toolbox/issue-document-form-toolbox';
import { IssueDocumentForm } from '../issue-document-form/issue-document-form';

export const IssueDocumentFormContent = ({
  formSchema,
  selectedDocumentModel,
  onDocumentTypeChange,
  availableDocuments,
  selectedDocumentType,
  availableLanguages,
}: IssueDocumentFormContentProps) => {
  const { t } = useTranslation('hq-screen-specific');
  const formMethods = useForm<IssueDocumentFormData>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      documentType: selectedDocumentType,
      language: availableLanguages[0],
    },
  });

  return (
    <FormProvider {...formMethods}>
      <Page
        header={<Header titleText={t('document_create.page_title')} />}
        toolbox={
          <Toolbox>
            <IssueDocumentFormToolbox />
          </Toolbox>
        }
      >
        <Box width="50%">
          <IssueDocumentForm
            selectedDocumentModel={
              selectedDocumentModel?.actions?.issue || { items: [], rules: [] }
            }
            onDocumentTypeChange={onDocumentTypeChange}
            availableDocuments={availableDocuments}
            availableLanguages={availableLanguages}
          />
        </Box>
      </Page>
    </FormProvider>
  );
};
